import { IdentityAuth } from './identity-auth';
export class MobileUtility {
    mobileUtility = null;
    static id = 'MobileUtility';
    static loginView = 'website_advert';
    static defaultLoginOption = 'enhanced';
    menuButton = null;
    closeButton = null;
    identityAuth = new IdentityAuth();
    init() {
        this.mobileUtility = document.getElementById(MobileUtility.id);
        if (!this.mobileUtility) {
            this._logError(`Element with ID '${MobileUtility.id}' not found. Cannot initialize mobile utility.`);
            return;
        }
        ;
        this.menuButton = document.querySelector('[data-mobile-toggle]');
        this.closeButton = document.querySelector(`#${MobileUtility.id}HeaderCloseMobileUtilityBtn`);
        if (!this.menuButton || !this.closeButton) {
            this._logError('Menu button or close button not found. Cannot initialize mobile utility.');
            return;
        }
        this._setMenuState(false);
        this._onMenuToggleEventHandler();
        this._onMenuCloseEventHandler();
        this._onRestrictedLoginLinkEventHandler();
    }
    _onMenuToggleEventHandler() {
        if (!this.menuButton) {
            this._logError('Menu button not found. Cannot attach event handler for toggling the menu.');
            return;
        }
        this.menuButton.addEventListener('click', () => this._setMenuState(!this._isMenuOpen()));
    }
    _onMenuCloseEventHandler() {
        if (!this.closeButton) {
            this._logError('Close button not found. Cannot attach event handler for closing the menu.');
            return;
        }
        this.closeButton.addEventListener('click', () => this._setMenuState(false));
    }
    _onRestrictedLoginLinkEventHandler() {
        this.mobileUtility?.addEventListener('click', async (event) => {
            const target = event.target;
            const link = target.closest('[data-auth-link]');
            if (!link) {
                return;
            }
            const { dialog, dialogHost } = this._getDialogElements();
            if (!dialog || !dialogHost) {
                this._logError('Unable to find required elements for login dialog.');
                return;
            }
            ;
            event.preventDefault();
            const query = new URLSearchParams({
                redirectPath: link.dataset['authRedirectPath'] ?? '/accounts',
                loginView: MobileUtility.loginView,
                defaultLoginOption: MobileUtility.defaultLoginOption,
                iFrameHeight: '320'
            });
            if (!dialog.open) {
                dialog.showModal();
            }
            const html = await this._fetchAuthenticationDialog(query);
            dialogHost.innerHTML = html;
            this.identityAuth.init(dialogHost);
        });
    }
    async _fetchAuthenticationDialog(query) {
        try {
            const response = await fetch(`/identity-auth/render-login-iframe?${query.toString()}`, {
                method: 'GET',
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!response.ok) {
                return `<div class="alert alert--error"><p>Unable to load login right now. Please try again.</p></div>`;
            }
            return await response.text();
        }
        catch {
            return `<div class="alert alert--error"><p>We could not connect to the server. Please try again.</p></div>`;
        }
    }
    _getDialogElements() {
        return {
            dialog: document.getElementById("LoginDialog"),
            dialogHost: document.getElementById("LoginDialogContent")
        };
    }
    _setMenuState(open) {
        if (!this.menuButton) {
            this._logError('Menu button not found. Cannot toggle menu state.');
            return;
        }
        document.body.classList.toggle('mobile-utility--open', open);
        this.menuButton?.classList.toggle('open', open);
        this.menuButton?.classList.toggle('closed', !open);
    }
    _isMenuOpen() {
        return document.body.classList.contains('mobile-utility--open');
    }
    _logError(message) {
        console.error(`MobileUtility: ${message}`);
    }
}
